import { useState, useEffect } from "react";

type DeviceType = "mobile" | "tablet" | "desktop";
type OrientationType = "portrait" | "landscape";

export const useResponsive = () => {
  const [device, setDevice] = useState<DeviceType>("desktop");
  const [orientation, setOrientation] = useState<OrientationType>("portrait");

  const handleResize = () => {
    const width = window.innerWidth;

    if (width < 600) {
      setDevice("mobile");
    } else if (width < 1024) {
      setDevice("tablet");
    } else {
      setDevice("desktop");
    }

    if (window.innerHeight > window.innerWidth) {
      setOrientation("portrait");
    } else {
      setOrientation("landscape");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return { device, orientation };
};
